import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useI18n } from '../i18n/I18nContext';
import { NavBar } from '../components/NavBar';
import { BackToHome } from '../components/BackToHome';
import { KeyRound, ArrowLeft } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ForgotPasswordPage = () => {
  const { t } = useI18n();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || t('forgot.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <NavBar />
      <BackToHome />
      <div className="max-w-md mx-auto px-4 py-10">
        <div className="bg-white rounded-2xl shadow-md border border-slate-100 p-8">
          <div className="text-center mb-6">
            <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-3">
              <KeyRound className="w-6 h-6 text-blue-600" />
            </div>
            <h1 className="text-2xl font-bold text-slate-900 font-['Outfit']">{t('forgot.heading')}</h1>
            <p className="text-sm text-slate-600 mt-2">{t('forgot.subtitle')}</p>
          </div>

          {sent ? (
            <div data-testid="forgot-sent" className="p-4 bg-green-50 border border-green-200 rounded-xl text-green-800 text-sm leading-relaxed">
              {t('forgot.sent')}
            </div>
          ) : (
            <form data-testid="forgot-form" onSubmit={onSubmit} className="space-y-4">
              {error && (
                <div data-testid="forgot-error" className="p-3 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm">{error}</div>
              )}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">{t('login.email')}</label>
                <input data-testid="forgot-email-input" type="email" required value={email}
                       onChange={(e) => setEmail(e.target.value)}
                       className="w-full px-4 py-3 rounded-xl border-slate-200 bg-slate-50 focus:ring-2 focus:ring-blue-500"
                       placeholder="you@example.com" />
              </div>
              <button data-testid="forgot-submit-btn" type="submit" disabled={loading}
                      className="w-full px-6 py-3 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 disabled:opacity-50">
                {loading ? t('forgot.sending') : t('forgot.submit')}
              </button>
            </form>
          )}

          <div className="mt-6 text-center">
            <Link to="/login" data-testid="link-back-to-login" className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-blue-600">
              <ArrowLeft className="w-4 h-4" /> {t('forgot.back_to_login')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
